/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AiGovernancePromptSummary extends models.AiGovernanceModelSummary {
    getFixupPrototypeFunction() { return AiGovernancePromptSummary.fixupPrototype; }

    static newInstance(model: Partial<AiGovernancePromptSummary>): AiGovernancePromptSummary {
        let obj = Object.assign(new AiGovernancePromptSummary(), model);
        AiGovernancePromptSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AiGovernancePromptSummary>): AiGovernancePromptSummary {
        if (!model) return null;
        return AiGovernancePromptSummary.newInstance(<AiGovernancePromptSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AiGovernancePromptSummary) {
        if (!obj) return;

        models.AiGovernancePromptSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AiGovernancePromptSummary): boolean {
        if (models.AiGovernanceModelSummary.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AiGovernancePromptSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Prompt text submitted to the model
     */
    prompt: string;

    /**
     * Unique identifier for the prompt invocation
     */
    prompt_id: string;

}
